import httpHelper from '../../../../utils/httpHelper';
import { appConfig } from '../../../../constants/appConfig';
import axios from 'axios';

const service = {
  async getReportingRequests(params, token) {
    const { param } = params;
    if (param.userId) {
      const endPoint = `/reporting-request/findByUserIdAndSchemaId`;
      const result = await axios.get(`${appConfig.hpc}${endPoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: param,
      });
      return result;
    } else {
      const endPoint = `/reporting-request/findBySchemaId/WeeklyFleetSafetyReport`;
      const result = await axios.get(`${appConfig.hpc}${endPoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: param,
      });
      return result;
    }
  },

  async getReportingResponses(params, token) {
    const endPoint = `/reporting-response`;
    const result = await axios.get(`${appConfig.hpc}${endPoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return result;
  },

  async getToken() {
    const endPoint = `/token`;
    const result = await httpHelper.makePostRequest(
      appConfig.tokenUrl,
      endPoint,
      {
        username: 'iok',
        password: '1',
      },
    );
    return result;
  },
};

export default service;
